import React, { useState, useEffect, useMemo } from 'react'
import { usePermissions } from 'api/hooks/use-permissions'
import Select, { components } from 'react-select'

function PermissionDropdown({ employeeId, params, setParams }) {
  const [selected, setSelected] = useState('')

  const defaultParams = {
    page: 1,
    perPage: 1000
  }

  const { Option } = components
  const { data: permissions, isSuccess } = usePermissions({
    params: defaultParams
  })

  const CustomOption = (props) => (
    <Option {...props}>
      <span className="me-1">{props.data.label}</span>
    </Option>
  )

  const SingleValue = ({ children, ...props }) => (
    <>
      <components.SingleValue {...props}>{children}</components.SingleValue>
    </>
  )

  // Group permissions by category_caption
  const groupedOptions = useMemo(() => {
    if (!isSuccess) return []
    const groups = permissions.data.reduce((acc, obj) => {
      if (!acc[obj.category_caption]) {
        acc[obj.category_caption] = {
          label: obj.category_caption,
          options: []
        }
      }
      acc[obj.category_caption].options.push({
        label: obj.description,
        value: obj.id,
        permissionId: obj.id
      })
      return acc
    }, {})
    // Sort the options within each group by description (label)
    Object.values(groups).forEach((group) => {
      group.options.sort((a, b) =>
        a?.label ? a.label.localeCompare(b.label) : Infinity
      )
    })
    // Sort the groups by category_caption (label)
    return Object.values(groups).sort((a, b) =>
      a?.label ? a.label.localeCompare(b.label) : Infinity
    )
  }, [isSuccess, permissions])

  useEffect(() => {
    if (params.permission_id && isSuccess) {
      // Find the selected option in groupedOptions
      let selectedOption = null
      for (const group of groupedOptions) {
        selectedOption = group.options.find(
          (option) => option.permissionId === params.permission_id
        )
        if (selectedOption) break
      }
      setSelected(selectedOption)
    } else {
      setSelected('')
    }
  }, [params.permission_id, isSuccess, groupedOptions])

  return (
    <>
      {isSuccess && (
        <Select
          options={groupedOptions}
          styles={{ zIndex: 100 }}
          value={selected}
          isClearable={true}
          placeholder="Select Permission"
          onChange={(val) => {
            setSelected(val)
            setParams({ ...params, permission_id: val?.value })
          }}
          id="permission-selector"
          isOptionDisabled={(option) => option.disabled}
          components={{ SingleValue, Option: CustomOption }}
        />
      )}
    </>
  )
}

export default PermissionDropdown
